(() => {
  const teamPath = /^\/collections\/nicholls-state-university(?:-adult-copy)?\/?$/;
  const fromNicholls = value => {
    try { const url = new URL(value, location.origin); return url.origin === location.origin && teamPath.test(url.pathname); }
    catch { return false; }
  };
  const isTeamContext = () => {
    if (fromNicholls(document.referrer)) return true;
    if (!['reload','back_forward'].includes(performance.getEntriesByType('navigation')[0]?.type)) return false;
    try {
      const context = JSON.parse(document.getElementById('SharpBrowseContext')?.textContent || '{}');
      const memory = JSON.parse(sessionStorage.getItem('sharp-browse-v1:' + context.theme) || '{}');
      return Object.values(memory.pages || {}).some(page => {
        const url = new URL(page.url, location.origin);
        const age = Date.now() - page.time;
        return url.pathname === location.pathname && age >= 0 && age < 7200000 && fromNicholls(page.previous?.url);
      });
    } catch { return false; }
  };
  const init = () => {
    const contextual = isTeamContext();
    document.querySelectorAll('product-info').forEach(root => {
      if (!root.hasAttribute('data-nicholls-fulfillment') && !contextual) return;
      root.setAttribute('data-nicholls-fulfillment','');
      root.querySelectorAll('[data-nicholls-fulfillment-status]').forEach(status => status.hidden = false);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  document.addEventListener('shopify:section:load',init);
})();
